'use es6';

import { combineReducers } from 'redux';
import TemplateBuffer from 'DesignData/models/TemplateBuffer';
import * as actions from 'DesignData/actions/ActionTypes';
import { EMPTY_OBJECT, createOptimizedPick } from 'DesignData/lib/object';
const pickChangeInfoAttrs = createOptimizedPick(['templateType', 'meta', 'isAvailableForNewContent', 'updated', 'updatedBy']);

function setChangeInfo(state, action, hasBufferedChanges) {
  const {
    templateId,
    template
  } = action;

  if (!template) {
    return state;
  }

  const changeInfo = pickChangeInfoAttrs(template);
  const updatedTemplate = state[templateId].merge(changeInfo).setIn(['meta', 'hasBufferedChanges'], hasBufferedChanges);
  return state.set(templateId, updatedTemplate);
}

function byId(state = EMPTY_OBJECT, action) {
  const {
    templateId
  } = action;

  switch (action.type) {
    case actions.TEMPLATE_CREATE:
    case actions.TEMPLATE_CREATE_FROM_FILE:
    case actions.TEMPLATE_BUFFER_DISCARD:
    case actions.TEMPLATE_BUFFER_FETCH:
    case actions.TEMPLATE_BUFFER_FETCH_BY_PATH:
    case actions.TEMPLATE_BUFFER_MOVE_RENAME:
      {
        const stateTemplate = state[templateId];
        const actionTemplate = action.template;
        let template;

        if (!action.template) {
          return state;
        }

        if (actionTemplate && !stateTemplate) {
          template = new TemplateBuffer(actionTemplate);
        }

        if (stateTemplate) {
          template = new TemplateBuffer(Object.assign({}, actionTemplate, {
            source: stateTemplate.source
          }));
        }

        return state.set(templateId, template);
      }

    case actions.TEMPLATE_BUFFER_REVERT:
      {
        if (!action.template) {
          return state;
        }

        const template = new TemplateBuffer(action.template);
        return state.set(templateId, template);
      }

    case actions.TEMPLATE_BUFFER_PUBLISH:
      return setChangeInfo(state, action, false);

    case actions.TEMPLATE_BUFFER_SAVE:
    case actions.TEMPLATE_BUFFER_SAVE_BY_PATH:
    case actions.TEMPLATE_SAVE_BY_PATH:
      {
        return setChangeInfo(state, action, true);
      }

    case actions.TEMPLATE_BUFFER_DELETE:
      {
        if (!action.error) {
          return state.without(templateId);
        }

        return state;
      }

    case actions.TEMPLATE_BUFFER_UPDATE_SOURCE:
      {
        const {
          source
        } = action;

        if (!(typeof source === 'string' && state[templateId])) {
          return state;
        }

        const updatedSourceTemplate = state[templateId].set('source', source);
        return state.set(templateId, updatedSourceTemplate);
      }

    default:
      {
        return state;
      }
  }
}

function getPendingReducer(requestActionTypes, receiveActionTypes) {
  return (state = EMPTY_OBJECT, action) => {
    const {
      templateId,
      type
    } = action;

    if (requestActionTypes.indexOf(type) !== -1) {
      return state.set(templateId, true);
    } else if (receiveActionTypes.indexOf(type) !== -1) {
      return state.set(templateId, false);
    } else {
      return state;
    }
  };
} // using plain object because can't retrieve Error object from Seamless map


function getErrorReducer(...actionTypes) {
  const types = new Set(actionTypes);
  return (state = {}, action) => {
    const {
      templateId,
      error
    } = action;

    if (types.has(action.type)) {
      return Object.assign({}, state, {
        [templateId]: error
      });
    }

    return state;
  };
}

export default combineReducers({
  byId,
  isSavingById: getPendingReducer([actions.TEMPLATE_BUFFER_SAVE_REQUEST, actions.TEMPLATE_BUFFER_SAVE_BY_PATH_REQUEST], [actions.TEMPLATE_BUFFER_SAVE, actions.TEMPLATE_BUFFER_SAVE_BY_PATH]),
  isPublishingById: getPendingReducer([actions.TEMPLATE_BUFFER_PUBLISH_REQUEST], [actions.TEMPLATE_BUFFER_PUBLISH]),
  saveErrorById: getErrorReducer(actions.TEMPLATE_BUFFER_SAVE),
  publishErrorById: getErrorReducer(actions.TEMPLATE_BUFFER_PUBLISH),
  cloneErrorById: getErrorReducer(actions.TEMPLATE_BUFFER_CLONE),
  moveRenameErrorById: getErrorReducer(actions.TEMPLATE_BUFFER_MOVE_RENAME),
  fetchErrorById: getErrorReducer(actions.TEMPLATE_BUFFER_FETCH, actions.TEMPLATE_BUFFER_FETCH_BY_PATH)
});